import { render, staticRenderFns } from "./assetDynamicBaseInfo.vue?vue&type=template&id=6e3cb9cc&scoped=true"
import script from "./assetDynamicBaseInfo.vue?vue&type=script&lang=js"
export * from "./assetDynamicBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./assetDynamicBaseInfo.vue?vue&type=style&index=0&id=6e3cb9cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cb9cc",
  null
  
)

export default component.exports